export const BILL_STATUS_CODES = {
  None: 0,
  PendingPosting: 1,
  PendingAuthorization: 2,
  Rejected: 3,
  Billed: 4,
  All: 5,
};

export const BILL_STATUS_TABS = [
  {
    key: "pending",
    label: "Pending",
    status: "PendingPosting",
    statusCode: BILL_STATUS_CODES.PendingPosting,
  },
  {
    key: "authorisation",
    label: "Authorisation",
    status: "PendingAuthorization",
    statusCode: BILL_STATUS_CODES.PendingAuthorization,
  },
  {
    key: "rejected",
    label: "Rejected",
    status: "Rejected",
    statusCode: BILL_STATUS_CODES.Rejected,
  },
  {
    key: "posted",
    label: "Posted",
    status: "Billed",
    statusCode: BILL_STATUS_CODES.Billed,
  },
];
